import Image from 'next/image';

import { cn } from '../lib/utils';

interface LogoTitleProps {
  logo: string;
  title: string;
  logoWidth?: number;
  logoHeight?: number;
  className?: string;
  logoClassName?: string;
  titleClassName?: string;
  alt?: string;
}

export function LogoTitle({
  logo,
  title,
  logoWidth = 64,
  logoHeight = 64,
  className,
  logoClassName,
  titleClassName,
  alt,
}: LogoTitleProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center lg:justify-start gap-4 mb-4',
        className
      )}
    >
      <Image
        src={logo}
        alt={alt || `${title} Logo`}
        width={logoWidth}
        height={logoHeight}
        className={logoClassName}
      />
      <span
        className={cn(
          'text-3xl font-bold tracking-tighter sm:text-5xl xl:text-6xl/none text-gray-900 dark:text-white',
          titleClassName
        )}
      >
        {title}
      </span>
    </div>
  );
}
